<template>
  <section class="m-index-new">
      <ul class="m-new-wrap-skeleton" v-if="data.length <= 0 && loading">
        <li class="m-new-item" v-for="(item, index) in 5" :key="index">
          <div class="m-new-goods">
            <div class="goods-img"></div>
            <div class="goods-title">
                <p></p>
                <p></p>
            </div>
          </div>
        </li>
      </ul>
    
      <ul class="m-new-wrap" v-else>
        <li class="m-new-item" v-for="(item, index) in data" :key="index">
          <router-link :to="{path: `/zh/goods/detail/${item.id}`, query: {pre: item.pre_info.is_pre == 1 ? 1 : 0}}" class="m-new-goods">
            <img :src="item.image_url" alt="goods">
            <div v-if="item.merchant_id == 1 && item.pre_info.is_pre == 0 && elevenShow" class="eleven"></div>
            <p class="van-multi-ellipsis--l2">
            <span class="m-mooby" v-if="item.merchant_id == 1 && item.pre_info.is_pre == 0">自营</span>
            <span class="m-mooby" v-if="item.pre_info.is_pre == 1">预售</span>
            <span v-if="item.goods_info">{{item.goods_info.name}}</span>
            </p> 
            <div class="goods-price">
              <p v-if="item.pre_info.is_pre == 1 && item.pre_info.pre_min_price != null">
                <span>$</span><span>{{item.pre_info.pre_min_price}}</span>
              </p>
              <p v-else>
                <span>$</span><span>{{(item.activity_min_price *1).toFixed(0) != 0 ? item.activity_min_price : (item.min_price * (item.off == 0 ? 1 : item.off / 100)).toFixed(2)}}</span>
                <span v-if="(item.activity_min_price *1).toFixed(0) != 0 ? true : item.off != 0">${{item.min_price}}</span>
              </p>
            </div>
          </router-link>
        </li>
        <li class="m-new-item"></li>
      </ul>

  </section>
</template>

<script>

export default {
  name:'IndexNew',
  props:['data', 'loading', 'isPre'],
  data () {
    return {
      elevenShow: false // 圣诞活动边框显示
    }
  },
}
</script>

<style lang="less" scoped>
.m-index-new {
  padding-left: 16px;
  margin-bottom: 5px;
  overflow-x: auto;
  overflow-y: hidden;
  transition: all 0.5s ease;
  .m-new-wrap {
    display: flex;
    list-style: none;
    width: auto;
    .m-new-item{
      margin-right: 12px;
      display: block;
      width: 130px;
      box-shadow: 0px 10px 15px 0px rgba(217, 217, 217, 0.384);
      border-radius: 0 0 8px 8px;
    }
    .m-new-item:last-child{
      min-width: 4px;
      box-shadow: none;
    }
    .m-new-goods {
      position: relative;
      display: inline-block;
      width: 130px;
      color: #333;
      &>img {
        width: 130px;
        height: 140px;
        border-radius: 5px;
      }
      &>.eleven{
        position: absolute;
        top: 0;
        left: 0;
        width: 130px;
        height: 140px;
        border-radius: 5px;
        background: url('../../assets/index/eleven.png') no-repeat center;
        background-size: 100% 100%;
      }
      &>p {
        margin-top: 8px;
        font-size: 12px;
        letter-spacing: 0.31px;
        line-height: 18px;
        padding:0 10px;
        &>span:nth-of-type(2){
          font-size: 12px;
          line-height: 20px;
        }
      }
      .goods-price {
        margin-top: 3px;
        font-size: 12px;
        padding:0 10px 10px 10px;
        &>p:nth-of-type(1){
          color: #ED2A24;
          &>span:nth-of-type(2){
            font-size: 16px;
          }
          &>span:nth-of-type(3){
            margin-top: 2px;
            margin-left:5px;
            font-size: 10px;
            color: #999999;
            text-decoration:line-through;
          }
          &>span:nth-of-type(3){
            margin-top: 2px;
            margin-left:5px;
            font-size: 10px;
            color: #999999;
            text-decoration:line-through;
          }
        }        
      }
    }
  }
  .m-new-wrap-skeleton{
    display: flex;
    list-style: none;
    width: auto;

    .m-new-item{
      margin-right: 12px;
      display: block;
      width: 130px;
      .m-new-goods {
        display: inline-block;
        width: 130px;
        color: #333;
        position: relative;
        .goods-img {
          width: 130px;
          height: 140px;
          border-radius:5px 5px 0px 0px;
          background: #f1f1f1;
        }
        .goods-title {
          width: 130px;
          font-size: 12px;
          letter-spacing: 0.31px;
          line-height: 18px;
          color: #333;
          margin:5px 0 10px 0;
          height:40px;
          >p{
              &:nth-of-type(1){width:100%;height:20px;background: #f1f1f1}
              &:nth-of-type(2){width:30%;height:20px;background: #f1f1f1;margin-top:5px}
          }
        }
      }
    }
  }
}
</style>